module.exports = __webpack_public_path__ + "./img/NovedadesInicio.ced9ba082a637b56aa92cc24a95e1fd5.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/NovedadesInicio.png
// module id = ./public/img/Help/NovedadesInicio.png
// module chunks = 0